/*global google*/
import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  MarkerClusterer,
  Autocomplete,
  DirectionsRenderer,
} from '@react-google-maps/api'
import { useRef, useState, useEffect, Fragment } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import logo from "../../images/logo.png";
import { Dropdown } from "react-bootstrap";
import { Row, Col, Card, Accordion } from "react-bootstrap";
import Switch from "react-switch";
import axios from "axios";
import { getInstancePublic } from '../../config/token';
import socketIOClient from "socket.io-client";

const defaultZoom = 14
// var loadjs = require('loadjs');
const LiveLocation = () => {
  const [map, setMap] = useState(/** @type google.maps.Map */(null))
  const [directionsResponse, setDirectionsResponse] = useState(null)
  const [distance, setDistance] = useState('')
  const [duration, setDuration] = useState('')
  const [lat, setLat] = useState(0.0000);
  const [lng, setLng] = useState(0.0000);
  const [startLat, setStartLat] = useState(0.0000);
  const [startLng, setStartLng] = useState(0.0000);
  const [zoom, setZoom] = useState(defaultZoom);
  const [activeDefault, setActiveDefault] = useState(0);
  const [darkMode, setDarkMode] = useState(false);
  const [preDarkMode, setPreDarkMode] = useState(false);
  const [deliveryType, setDeliveryType] = useState(1); //1=delivery, 2=pickup
  const [tripStatus, setTripStatus] = useState(0); //0=pending, 1=completed
  const [tripId, setTripId] = useState(null);
  const [tripToken, setTripToken] = useState(null);
  const [orderItem, setOrderItem] = useState([]);
  const [orderDetail, setOrderDetail] = useState(null);
  const [userData, setUserData] = useState(null);
  const [userVehicleData, setUserVehicleData] = useState(null);
  const [loadingMap, setLoadingMap] = useState(null);
  const [completedDate, setCompletedDate] = useState(null)
  const [showMapLoader, setShowMapLoader] = useState(false)
  // const [destLat, setDestLat] = useState(40.7137919238253); //live
  // const [destLng, setDestLng] = useState(-74.01501527384697); //live
  const [realTime, setRealTime] = useState(new Date())
  const [dataAvaialbe, setDataAvaialbe] = useState(true)

  // const [destLat, setDestLat] = useState(23.024826812533117); //local
  // const [destLng, setDestLng] = useState(72.50694258151395); //local

  const [destLat, setDestLat] = useState(0.0000); //local
  const [destLng, setDestLng] = useState(0.0000); //local




  const darkModeStyle = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ]

  useEffect(() => {
    // document.title = "Track My Gear"
    let path = window.location.pathname.split("/");
    let token = path[path.length - 1];
    if (token) {
      let requestObj = {
        token: token
      }
      setLoadingMap(true)
      setShowMapLoader(true)
      let config = getInstancePublic('POST', `/api/trip_detail`, requestObj);
      axios(config)
        .then((res) => {
          if (res.data && res.data.id) {
            setDataAvaialbe(true)
            setTripId(res.data.id)
            localStorage.setItem("tripId", res.data.id)
            localStorage.setItem("tripStatus", res.data.status ? 1 : 0)
            let locationData = res.data
            if (locationData.start_lat && locationData.start_lng) {

              setStartLat(locationData.start_lat)
              setStartLng(locationData.start_lng)
              setLat(locationData.start_lat)
              setLng(locationData.start_lng)
            }
            if (locationData.end_lat && locationData.end_lng) {
              setDestLat(locationData.end_lat)
              setDestLng(locationData.end_lng)
            }
            setDeliveryType(locationData.type ? locationData.type : 1)
            setTripStatus(locationData.status ? 1 : 0)

            setTripToken(locationData.token)
            setCompletedDate(locationData.completed_at)
            setOrderDetail(locationData.order)
            if (locationData.order && locationData.order.order_items) {
              setOrderItem(locationData.order.order_items)
            }
            if (locationData.user) {
              setUserData(locationData.user)
            }
            if (locationData.user_vehicle) {
              setUserVehicleData(locationData.user_vehicle)
            }
          } else {
            setDataAvaialbe(false)
          }
          setLoadingMap(false)
        })
        .catch((err) => {
          console.log(err)
          setLoadingMap(false)
        });
    } else {
      console.log("No token message")
    }

    // Socket Listining


    // const socket = socketIOClient(process.env.REACT_APP_API_URL, {transports: ['websocket']});
    // socket.on('connect', function() {
    //   console.log("Location socket connected");
    // });


    // socket.on("locationCompleted", data => {
    //   if(data.tripId && data.tripId == tripId && tripStatus == 0){
    //     window.location.reload();
    //   }
    // });

    // Live Clock

    const timeTimer = setInterval(() => { // Creates an interval which will update the current data every minute
      // This will trigger a rerender every component that uses the useDate hook.
      setRealTime(new Date());
    }, 1000);

    // Load external js

    const timer = setTimeout(() => {
      const script = document.createElement('script');
      script.src = "https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js";
      script.async = true;
      document.body.appendChild(script);
    }, 3000);
    return () => {
      clearTimeout(timer);
      clearInterval(timeTimer);
    }


  }, [])

  useEffect(() => {
    const socket = socketIOClient(process.env.REACT_APP_API_URL, { transports: ['websocket'] });
    socket.on("locationUpdate", onLocationUpdate)
    socket.on("locationCompleted", data => {
      if (data.tripId && data.tripId == parseInt(localStorage.getItem("tripId"))) {
        window.location.reload();
      }
    });
  }, [])

  const onLocationUpdate = (data) => {
    if (data && data.lat && data.lng && data.tripId) {
      if (data.tripId == parseInt(localStorage.getItem("tripId")) && parseInt(localStorage.getItem("tripStatus")) != 1) {
        if (startLat == 0.0000 || startLng == 0.0000) {
          setStartLat(data.lat)
          setStartLng(data.lng)
          let req = {
            startLat: data.lat,
            startLng: data.lng,
            tripId: parseInt(localStorage.getItem("tripId"))
          }
          let config = getInstancePublic('POST', `/api/location_update`, req);
          axios(config)
            .then((res) => {
              console.log("Start location saved.", res)
            })
            .catch((err) => {
              console.log(err)
            });
        }
        setLat(data.lat)
        setLng(data.lng)
      }
    }
  }

  // useEffect(() => {
  //   document.title = "Track My Gear"
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.watchPosition(position => {
  //       setLat(position.coords.latitude)
  //       setLng(position.coords.longitude)

  //       if (startLat == 0.0000 && startLng == 0.0000) {
  //         setStartLat(position.coords.latitude)
  //         setStartLng(position.coords.longitude)
  //       }
  //     })
  //   } else {
  //     console.log("Sorry, geolocation is not available on your device. You need that to use this app");
  //   }
  //   // const timer = setInterval(() => { // Creates an interval which will update the current data every minute
  //   //   // This will trigger a rerender every component that uses the useDate hook.
  //   //   setRealTime(new Date());
  //   // }, 1000);
  //   // return () => {
  //   //   clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
  //   // }
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     // loadjs('https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js', function() {
  //     // })
  //       const script = document.createElement('script');
  //       script.src = "https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js";
  //       script.async = true;
  //       document.body.appendChild(script);
  //       // setDarkMode(true)
  //   }, 3000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    calculateRoute()
  }, [lat, lng, map, destLat, destLng]);

  const defaultAccordion = [
    {
      title: "When will by delivery arrive?",
      text:
        "Please see the updated arrival time above. Weather, traffic patterns and unforeseen circumstances may incur a slight delay.",
      bg: "info",
    },
    {
      title: "Do I have to be at the location for delivery or pickup? ",
      text:
        "No you do not. We will deliver the items to a safe location and if we are picking up please leave the items in a safe location so the driver may retrieve it.",

      bg: "info",
    },
    {
      title: "Can I change the location of my delivery?",
      text:
        "Since the items are on its way, you cannot change the location. More questions? Call 844-795-1539 between 9am-5pm EST.",

      bg: "info",
    },
    {
      title: "How do I prepare the items for return? ",
      text:
        "Please make sure any items delivered in a box is back in the box and any crib mattresses are back in its packaging.",

      bg: "info",
    },
  ];

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAJ-YSuDVosXBWVTQAAb7MbLpyjpMoHaC0",
    // libraries: ['places'],
    id: 'google-map-script',
  })


  // const destiantionRef = useRef()

  if (!isLoaded) {
    return <div
      style={{
        textAlign: "center",
        width: "100%",
        position: "absolute",
        marginBottom: "10px",
      }}
    >
      <Spinner animation="border" role="status">
        <span className="visually-hidden"></span>
      </Spinner>
    </div>
  }

  async function calculateRoute() {
    if (lat == '' || lng == '' || !destLat || !destLng || !lat || !lng || !map) {
      return
    }

    if (!window.google) {
      setLoadingMap(true)
      setTimeout(() => {
        calculateRoute()
      }, 2000);
      return
    } else {
      setLoadingMap(false)
    }

    const places = [{ "latitude": parseFloat(lat), "longitude": parseFloat(lng) }, { "latitude": parseFloat(destLat), "longitude": parseFloat(destLng) }]

    const waypoints = places.map(p => ({
      location: { lat: p.latitude, lng: p.longitude },
      stopover: true
    }))
    const origin = waypoints.shift().location;
    const destination = waypoints.pop().location;

    // eslint-disable-next-line no-undef
    var bounds = new window.google.maps.LatLngBounds();
    const directionsService = new window.google.maps.DirectionsService()
    const results = await directionsService.route({
      origin: origin,
      destination: destination,
      travelMode: 'DRIVING',
      drivingOptions: {
        departureTime: new Date(),
        trafficModel: "bestguess"
      }
    })
    bounds.union(results.routes[0].bounds);
    console.log("zoooommmmmmmmmmmm", zoom, defaultZoom)
    if (map && zoom == defaultZoom) {
      map.fitBounds(bounds);
    }
    // showSteps(results)
    // console.log("testttttttttttttttttttttttttttttttttttttt", results)
    // setDarkMode(preDarkMode)
    setShowMapLoader(false)
    setDirectionsResponse(results)
    setDistance(results.routes[0].legs[0].distance.text)
    setDuration(results.routes[0].legs[0].duration_in_traffic ? results.routes[0].legs[0].duration_in_traffic.text : results.routes[0].legs[0].duration.text)
  }

  const handleChange = () => {
    setDarkMode(!darkMode)
    calculateRoute()
  }

  return (
    <div style={{ overflowX: "hidden", minHeight : "708px" }}>
      {loadingMap ?
        <div
          style={{
            textAlign: "center",
            width: "100%",
            position: "absolute",
            marginBottom: "10px",
            top: "50%"
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden"></span>
          </Spinner>
        </div> :
        dataAvaialbe ? 
        <Fragment>
          <div className="staticBar" style={{ backgroundColor: "#3D455A", width: '100%', height: "3rem", borderBottom: "1px solid white" }}>
            <a href="https://trackmygear.babiesgetaway.com">
              <img style={{ width: '100px' }} src="https://www.babiesgetaway.com/public/img/logo_web_white.png" alt="Babies Getaway" />
            </a>
            <label style={{ marginBottom: "0px", marginTop: "5px" }}>
              <span className='darkModeFont'>Dark Mode</span>
              <div style={{ verticalAlign: "middle", display: "inline-block" }}>
                <Switch onChange={handleChange} checked={darkMode} />
              </div>
            </label>
          </div>
          <div style={{ backgroundColor: "#3D455A" }}>
            <div className="arrows">
              <div className="arrow step1">
                <span>{deliveryType == 1 ? "Delivery in Progress" : "Pickup in Progress"}</span>
              </div>
              <div className={tripStatus ? "arrow step2 arrow-completed" : "arrow step2"} >
                <span>{deliveryType == 1 ? "✅ Delivery Completed" : "✅ Pickup Completed"}</span>
              </div>
              {/* <div class="arrow step3">
            <span>3. Listen</span>
          </div> */}
            </div>
            <div style={{textAlign : "center", marginTop : "10px", paddingBottom : "10px", color : "#ffffff"}}><span>{"Current Time : " +
                new Date(
                  realTime
                ).toLocaleString('en-US')}</span>
                <br />
              <span>Pickup Window: 9-11am</span>
              </div>
          </div>
          <div className='mapContainterHeight' style={{ width: '100%',/* marginTop: "3rem",*/ overflowX: "hidden" }}>
            {/* {showMapLoader ? 
             <div
             style={{
               textAlign: "center",
               width: "100%",
               position: "absolute",
               marginBottom: "10px",
             }}
           >
             <Spinner animation="border" role="status">
               <span className="visually-hidden"></span>
             </Spinner>
           </div>
            : */}
            
            <GoogleMap
              // center={center}
              // center={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
              zoom={zoom}
              mapContainerStyle={{ width: '100%', height: '100%' }}
              options={{
                // zoomControl: true,
                gestureHandling: 'cooperative',
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                // keyboardShortcuts:false,
                styles: darkMode ? darkModeStyle : [],
              }}
              onLoad={(map) => {
                setMap(map)
                // calculateRoute()
              }}
              onZoomChanged={() => map ? setZoom(map.getZoom()) : ""}
            >
              <Marker
                // icon={"https://api.babiesgetaway.com/upload/1654089520703-bgimg.png"}
                label={{
                  text: "\ue558",
                  fontFamily: "Material Icons",
                  color: "#ffffff",
                  fontSize: "20px"
                }}
                title="Starting"
                position={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
              />
              <Marker
                // icon={"https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|FE634E"}
                //   icon= {{
                //     // path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                //     fillColor: "black",
                //     fillOpacity : "1"
                //     // scale: 3
                // }}
                label={{
                  text: "\ue88a",
                  fontFamily: "Material Icons",
                  color: "#ffffff",
                  fontSize: "20px",
                }}
                title="Destination"
                position={{ lat: parseFloat(destLat), lng: parseFloat(destLng) }}
              />
              {directionsResponse && (
                <DirectionsRenderer directions={directionsResponse}
                  options={{
                    preserveViewport: true,
                    suppressMarkers: true,
                    polylineOptions: {
                      // strokeOpacity: 4,
                      strokeColor: darkMode ? '#FE634E' : '#3D455A',
                      strokeWeight: 6
                    },
                  }} />
              )}
            </GoogleMap>
{/* } */}
          </div>
          <div className='realtime-map-update' style={{ height: tripStatus ? "30px" : "100px" }}>
            <div style={{ position: 'absolute', right: '30px', zIndex: 1 , width : "225px"}}>
              {tripStatus ?
                "REAL TIME UPDATES OFF"
                :
                <Fragment>REAL TIME UPDATES
                  <Spinner className='loading-map' animation="grow" />
                  <Spinner className='loading-map' animation="grow" />
                  <Spinner className='loading-map' animation="grow" /></Fragment>
              }
              {/* <br /><span>{"Current Time : " +
                new Date(
                  realTime
                ).toLocaleString('en-US')}</span>
              <br /><span>Pickup Window: 9-11am</span> */}
              {tripStatus ? "" : <Fragment><br /><span style={{ color: "#FE634E" }}>ETA : <span style={{ textDecoration: "underline" }}>{duration}</span></span></Fragment>}
              {tripStatus ? "" : <Fragment><br /><span >* Driver may be making other stops along the route. Please be patient. *</span></Fragment>}
              
            </div>
          </div>
          <Row style={{ top: "7rem", margin: '0px' }}>
            <Col xl="12" style={{ padding: '0px' }}>
              <Card className='map-detail-card'>
                <Row>
                  <Col xl="6">
                    <Card.Header className="d-block card-header" style={{ padding: "1.5rem 1.875rem 1.25rem" }}>
                      <div className="profile-uoloaded-post border-bottom-1">
                        <div className="media pt-3 pb-3">
                          <Col style={{ flexGrow: "0" }}>
                            <img
                              src={userData && userData.profile_picture ? process.env
                                .REACT_APP_IMAGE_URL +
                                userData.profile_picture : "https://www.babiesgetaway.com/public/img/profile_pictures/no-image.png"}
                              alt=""
                              className="mr-3 rounded"
                              width={100}
                            />
                            <span className="star-review d-inline-block mb-2 fs-20 wspace-no" style={{fontSize : "20px !important"}}>
                              <i className="fa fa-star fs-16 text-orange"></i>{" "}
                              <i className="fa fa-star fs-16 text-orange"></i>{" "}
                              <i className="fa fa-star fs-16 text-orange"></i>{" "}
                              <i className="fa fa-star fs-16 text-orange"></i>{" "}
                              <i className="fa fa-star fs-16 text-orange"></i>{" "}
                              {/* <i className="fa fa-star fs-16 text-gray"></i>{" 45"} */}
                            </span>
                          </Col>
                          <div className="media-body" style={{ overflow: "auto", marginTop: "10px" }}>
                            <h5 className="m-b-5" style={{ fontWeight: "600", color: "white" }}>
                              {userData && userData.first_name ? userData.first_name + " " + userData.last_name : " "}
                            </h5>
                            <span className='span-map'>{"Babies Getaway U.S"}</span>
                            <a style={{ cursor: "pointer", width: "fit-content", color: "white" }} href={'tel:+1844-795-1539'}>{"844-795-1539"}</a>
                            {userVehicleData && userVehicleData.make_name && userVehicleData.model_name ? <Fragment><span className='span-map'>{userVehicleData.make_name + " " + userVehicleData.model_name}</span></Fragment> : ""}
                            {/* <p className="mb-0">{item.message}</p> */}
                          </div>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body className="card-body" style={{ padding: "1.875rem" }}>
                      <div style={{ paddingLeft: "15px" }} >
                        {tripStatus && deliveryType == 1 ? 
                        <Row>
                          <Col xl="6">
                          <div style={{ /*width: "fit-content"*/textAlign : "center" }}>
                              <a className="btn btn-secondary" href="" style={{ backgroundColor: "#FE634E", borderColor: "#FE634E", pointerEvents: "none", cursor: "default" }}>
                                {tripStatus ?
                                  deliveryType == 1 ? "Delivery Completed" : "Pickup Compleyted"
                                  : deliveryType == 1 ? "Delivery in Progress" : "Pickup in progress"
                                }
                              </a>
                              {completedDate && tripStatus ? <Fragment><br /><span style={{ textAlign: "center" }}>
                                {new Date(
                                  completedDate
                                ).toLocaleString('en-US')} </span></Fragment> : ""}
                                {orderDetail && orderDetail.provider_item_left_at ? 
                                <Fragment>
                                <p style={{ textAlign: "center" }}>
                                Left At : {orderDetail.provider_item_left_at} </p>
                                </Fragment>
                              :""}
                            </div>
                            <span style={{ paddingTop: "20px" }}><strong>Notes</strong> :</span>
                            <p>{orderDetail && orderDetail.notes ? orderDetail.notes : ""}</p>
                            {/* <Row> */}
                            {/* <Col xm="6"> */}
                            <p><strong> Destination : </strong>{
                              orderDetail ?
                                deliveryType == 1 ?
                                  orderDetail.shipping_city + ", " + orderDetail.shipping_state + " " + orderDetail.shipping_pincode
                                  :
                                  orderDetail.pickup_city + ", " + orderDetail.pickup_state + " " + orderDetail.pickup_pincode
                                : ""}</p>
                            <span><strong> Items & Qty</strong> :</span>
                            {orderItem.map(function (name, i) {
                              return (
                                <p>
                                  {"( " + name.ordered_qty + " ) " + name.product.name}
                                  <br />
                                </p>
                              );
                            })}
                          </Col>
                          <Col xl="6">
                            {tripStatus && orderDetail && orderDetail.delivery_image ? <Fragment><img src={"https://babiesgetaway.com/public/img/orders/" + orderDetail.delivery_image} style={{ height: "100%", width: "100%", borderRadius: "1.25rem" }} /></Fragment> : ""}
                          </Col>
                        </Row> : 
                        <Fragment>
                          <div style={{ /*width: "fit-content"*/textAlign : "center", marginBottom : "20px" }}>
                              <a className="btn btn-secondary" href="" style={{ backgroundColor: "#FE634E", borderColor: "#FE634E", pointerEvents: "none", cursor: "default", marginBottom : "10px" }}>
                                {tripStatus ?
                                  deliveryType == 1 ? "Delivery Completed" : "Pickup Compleyted"
                                  : deliveryType == 1 ? "Delivery in Progress" : "Pickup in progress"
                                }
                              </a>
                              {completedDate && tripStatus ? <Fragment><p style={{ textAlign: "center" }}>
                                {new Date(
                                  completedDate
                                ).toLocaleString('en-US')} </p></Fragment> : ""}
                            </div>
                            <span style={{ paddingTop: "20px" }}><strong>Notes</strong> :</span>
                            <p>{orderDetail && orderDetail.notes ? orderDetail.notes : ""}</p>
                            {/* <Row> */}
                            {/* <Col xm="6"> */}
                            <p><strong> Destination : </strong>{
                              orderDetail ?
                                deliveryType == 1 ?
                                  orderDetail.shipping_city + ", " + orderDetail.shipping_state + " " + orderDetail.shipping_pincode
                                  :
                                  orderDetail.pickup_city + ", " + orderDetail.pickup_state + " " + orderDetail.pickup_pincode
                                : ""}</p>
                            <span><strong> Items & Qty</strong> :</span>
                            {orderItem.map(function (name, i) {
                              return (
                                <p>
                                  {"( " + name.ordered_qty + " ) " + name.product.name}
                                  <br />
                                </p>
                              );
                            })}
                        </Fragment>
}
                      </div>
                    </Card.Body>
                    <hr style={{ borderTop: "1px solid white" }}></hr>
                  </Col>
                  <Col xl="6">
                    <Card.Header className="d-block card-header" style={{ padding: "1.5rem 1.875rem 1.25rem" }}>
                      <Card.Title style={{ color: "white", fontWeight : "700", textDecoration : 'underline' }}>FAQ's</Card.Title>
                    </Card.Header>
                    <Card.Body className="card-body" style={{ padding: "1.875rem" }}>
                      <Accordion
                        className="accordion accordion-primary"
                        defaultActiveKey="0"
                      >
                        {defaultAccordion.map((d, i) => (
                          <div className="accordion__item" key={i}>
                            <Accordion.Toggle
                              as={Card.Text}
                              eventKey={`${i}`}
                              className={`accordion__header rounded-lg ${activeDefault === i ? "" : "collapsed"
                                }`}
                              onClick={() =>
                                setActiveDefault(activeDefault === i ? -1 : i)
                              }
                            >
                              <span className="accordion__header--text">{d.title}</span>
                              <span className="accordion__header--indicator"></span>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={`${i}`}>
                              <div className="accordion__body--text">{d.text}</div>
                            </Accordion.Collapse>
                          </div>
                        ))}
                      </Accordion>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </Col>
            <div
              style={{ width: "100%" }}
              className="apple-business-chat-banner-container"
              data-apple-business-id="313f0823-354f-45e2-b03d-5dab99d5608e"
              data-apple-business-phone="844-795-1539"
              data-apple-banner-cta="CONTACT A BABY GEAR GURU"
              data-apple-banner-context="Chat with us about renting baby gear or an existing rental."
              data-apple-banner-rounded-corners="true"
              data-apple-banner-scale="1.3"
              data-apple-banner-background-color="#3D455A"
              data-apple-banner-text-color="#ffffff"
              data-apple-banner-icon-background-color="#ffffff"
              data-apple-banner-icon-color="#3D455A"
              data-apple-banner-orientation="vertical"
              data-apple-icon-scale="1"
              data-apple-icon-title="CONTACT A BABY GEAR GURU">
            </div>
          </Row>
        </Fragment> :
         <div
         style={{
           textAlign: "center",
           width: "100%",
           position: "absolute",
           marginBottom: "10px",
           top: "50%"
         }}
       >
        Trip does not exist or incorrect url for tracking trip. Questions? 844-795-1539
       </div>
      }
    </div>
  )
}

export default LiveLocation;